import { userIdQuery } from '../../authentication/queries';
import { createCommand } from '../../utils';
import { moduleName, setColumnVisibility } from '../state';

const LoadColumnsPreferenceCommand = createCommand(
    `${moduleName}/LOAD_COLUMNS_PREFERENCE`,
    async (_, { dispatch, extra, getState }) => {
        const userId = userIdQuery(getState());
        if (userId) {
            const saved = extra.externalProjectConfiguration.loadColumnVisibility(userId);

            // if no pref saved yet, use default values
            if (saved && Object.keys(saved).length > 0) {
                dispatch(setColumnVisibility(saved));
            }
        }
    },
);

export default LoadColumnsPreferenceCommand;
